"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualCoinManagementV1 = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
class DualCoinManagementV1 {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    getRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, token, params);
    }
    postRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, token, params);
    }
    // 请求产品列表
    queryProducts() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/dual_pre/products/";
        return this.getRequest(url).pipe((0, operators_1.map)((data) => {
            return data.list;
        }));
    }
    // 请求是否拥有投资权限
    getPermissionType() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/dual_pre/application/";
        return this.getRequest(url);
    }
    // 申请投资权限
    applyForPermission(request) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/dual_pre/application/";
        return this.postRequest(url, request);
    }
    // 申购
    invest(request) {
        if (!request.base_amount && !request.currency_amount) {
            return (0, rxjs_1.throwError)("base_amount or currency_amount need one");
        }
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/dual_pre/invest/";
        return this.postRequest(url, request);
    }
    // 已申购列表
    investRecords(product_id) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/dual_pre/invest/records/";
        return this.getRequest(url, {
            product_id: product_id,
        }).pipe((0, operators_1.map)((data) => {
            return data.list;
        }));
    }
    /*获取 entrust 权限*/
    getEntrustPermission() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/entrust/application/";
        return this.getRequest(url);
    }
    /*获取 entrust 产品列表*/
    queryEntrustProducts() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/entrust/products/";
        return this.getRequest(url).pipe((0, operators_1.map)((data) => {
            return data.list;
        }));
    }
    /* 获取 entrust 已申购列表 */
    queryEntrustRecords(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/entrust/invest/records/";
        return this.getRequest(url, param).pipe((0, operators_1.map)((data) => {
            return {
                has_more: data.has_more,
                next_token: data.next_token,
                records: data.records,
            };
        }));
    }
    /* 申购 entrust */
    investEntrust(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST +
            "/entrust/invest/";
        return this.postRequest(url, JSON.stringify(params));
    }
}
exports.DualCoinManagementV1 = DualCoinManagementV1;
